import { Link } from "react-router";

import { Trans, useTranslation } from "@punto/frontend-shared/i18n/i18next";
import { COOKIE_POLICY_URL } from "@punto/frontend-shared/utils/cookie-consent";

import { config } from "@/lib/config";

import { isSummerScheduleActive } from "./summer-schedule";

export const Footer = () => {
  const { t } = useTranslation();
  const email = config.CONTACT_EMAIL;

  return (
    <footer className="bg-muted py-8">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
        {t("Footer.schedule")}{" "}
        {isSummerScheduleActive() && <>{t("Footer.summerSchedule")} </>}
        <Trans
          i18nKey="Footer.contact"
          values={{ email }}
          components={{
            email: <Link to={`mailto:${email}`} className="underline" />,
          }}
        />
      </div>
      <div className="container mx-auto px-4 pt-2 text-center text-sm text-muted-foreground">
        {config.FOOTER_COPYRIGHT} © {new Date().getFullYear()} –{" "}
        <a
          href={COOKIE_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-foreground"
        >
          {t("Footer.reviewCookies")}
        </a>
      </div>
    </footer>
  );
};
